var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"knowledge-iframe",attrs:{"src":_vm.URL}})])}
var staticRenderFns = []

export { render, staticRenderFns }